import { type Meta } from '../types/docs';

export const EDIT_IN_CANVAS_OPENED_ACTIONS = [
  'add_solid_background',
  'adjust_image',
  'camera_angle',
  'camera_motion',
  'change_lighting',
  'convert',
  'convert_to_gif',
  'crop',
  'edit_text',
  'erase',
  'extend_background',
  'extend_video',
  'flip_and_rotate',
  'image_to_video',
  'open',
  'prompt',
  'remove_background',
  'resize_for_set',
  'smart_resize',
  'split_elements',
  'translate',
  'upscale',
] as const;

export type EditInCanvasOpenedAction = (typeof EDIT_IN_CANVAS_OPENED_ACTIONS)[number];

const META: Meta = {
  description:
    'User chose Edit in canvas from a gallery, table, hover, multi-select, or asset modal header surface, or Crop and edit on Canvas from Export As (a single image, or a multi-select from the gallery, table, or selection bar). Fires when the draft canvas opens, before any backend canvas exists.',
  name: 'edit_in_canvas_opened',
  params: [
    {
      description: 'The UI surface that opened Edit in canvas',
      name: 'opened_from',
      required: true,
      type: 'enum',
      values: [
        'action_bar',
        'action_bar_export_as',
        'announcement',
        'asset_card_hover',
        'asset_context_menu',
        'asset_modal_export_as',
        'asset_modal_header_menu',
        'asset_modal_quick_tools',
        'asset_modal_versions_menu',
        'asset_modal_video_editor',
        'gallery_item_context_menu',
        'gallery_item_ellipsis_menu',
        'gallery_item_export_as',
        'gallery_multi_select_context_menu',
        'gallery_multi_select_ellipsis_menu',
        'gallery_multi_select_export_as',
        'table_item_context_menu',
        'table_item_ellipsis_menu',
        'table_item_export_as',
        'table_multi_select_context_menu',
        'table_multi_select_ellipsis_menu',
        'table_multi_select_export_as',
      ],
    },
    {
      description: 'The Edit in canvas job the user picked. "open" is open-only, with no pending tool.',
      name: 'action',
      required: true,
      type: 'enum',
      values: [...EDIT_IN_CANVAS_OPENED_ACTIONS],
    },
    {
      description: 'How many clips were sent into the new canvas',
      name: 'clip_count',
      required: true,
      type: 'number',
    },
    {
      description: 'The id of the board the user was browsing, when on a board',
      name: 'board_id',
      required: false,
      type: 'string',
    },
    {
      description:
        'Whether the Edit in Canvas submenu qualified for Resize for [set name] (same meaning as on edit_in_canvas_submenu_shown). Sent only when opened from the Edit in Canvas submenu.',
      name: 'size_set_eligible',
      required: false,
      type: 'boolean',
    },
    {
      description:
        'Whether the Resize for [set name] item was rendered in the Edit in Canvas submenu (same meaning as on edit_in_canvas_submenu_shown). Sent only when opened from the Edit in Canvas submenu.',
      name: 'size_set_offered',
      required: false,
      type: 'boolean',
    },
    {
      description: 'The id of the saved size set used. Sent only when action is resize_for_set.',
      name: 'size_set_id',
      required: false,
      type: 'string',
    },
    {
      description: 'How many sizes the saved size set resolves to. Sent only when action is resize_for_set.',
      name: 'size_set_format_count',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
